import { render, staticRenderFns } from "./FreeDelivery.vue?vue&type=template&id=673feb07&"
import script from "./FreeDelivery.vue?vue&type=script&lang=js&"
export * from "./FreeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./FreeDelivery.vue?vue&type=style&index=0&id=673feb07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports